module.exports = __webpack_public_path__ + "static/media/icn_noimage_coverart.62491a07.svg";